/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {appsAPI} from '../../services/AppsService'
import {KTSVG} from '../../template/helpers'
import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {IAppsModel} from '../../types/apps/AppsModel'
import {ListCDRHeaderWrapper} from './components/ListCDRHeaderWrapper'
import {ListCDRItem} from './components/ListCDRItem'
import {useAccount} from '../../hooks/useAccount'

const ListCDRPage: FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const [appsWithCDR, updateAppsWithCDR] = useState<IAppsModel[]>()
  const {currentAccountIdForRequest: accountId, isOwner} = useAccount()
  const {data: apps, isLoading} = appsAPI.useFetchAppsMeQuery(
    {account_id: accountId},
    {refetchOnMountOrArgChange: true}
  )

  useEffect(() => {
    if (apps) {
      const listCDR = apps.filter((item) => item.extensions?.cdr === true)

      if (listCDR.length > 0 && listCDR.length < 2) {
        const appId = listCDR[0].id
        navigate(`/cdr/${appId}/`, {replace: true})
      } else {
        updateAppsWithCDR(listCDR)
      }
    }
  }, [apps, navigate])

  return (
    <>
      {isLoading ? (
        intl.formatMessage({id: 'WAIT'})
      ) : (
        <>
          {appsWithCDR?.length! > 1 ? (
            <ListCDRHeaderWrapper>
              <div className='py-0 accordion accordion-icon-toggle'>
                {appsWithCDR?.map((app, index) => (
                  <div key={index}>
                    <ListCDRItem key={index} app={app} />
                    {appsWithCDR.slice(-1)[0] !== app && <div className='separator separator-dashed' />}
                  </div>
                ))}
              </div>
            </ListCDRHeaderWrapper>
          ) : (
            <>
              <div className='d-flex flex-row h-500px'>
                <div className='d-flex flex-column flex-row-fluid'>
                  <div className='d-flex flex-row flex-column-fluid'>
                    <div className='d-flex flex-row-fluid flex-center'>
                      <div className='card-0 text-center'>
                        <KTSVG
                          path='/media/icons/duotune/files/fil002.svg'
                          className='svg-icon-primary svg-icon-3x me-2'
                        />
                        <div className='card-header py-4'>
                          {isOwner ? (
                            <>
                              <h3 className='card-title mb-2'>{intl.formatMessage({id: 'APPS.CDR'})}</h3>
                              <span>{intl.formatMessage({id: 'APPS.CDR.DESCRIPTION'})}</span>
                            </>
                          ) : (
                            <>
                              <h3 className='card-title mb-2'>{intl.formatMessage({id: 'APPS.CDR.NO_APPS'})}</h3>
                            </>
                          )}
                        </div>
                        {isOwner && (
                          <div className='card-body'>
                            {apps && apps?.length === 0 && (
                              <>
                                <a
                                  className='btn btn-primary'
                                  data-bs-toggle='modal'
                                  data-bs-target='#kt_modal_create_app'
                                  id='kt_toolbar_primary_button'
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrows/arr009.svg'
                                    className='svg-icon-muted svg-icon-1x'
                                  />
                                  {intl.formatMessage({id: 'APPS.CREATE.TITTLE.BUTTON'})}
                                </a>
                                <a
                                  href='https://wiki.callbee.io/'
                                  target='_blank'
                                  className='btn btn-secondary ms-2'
                                  rel='noreferrer'
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/arrows/arr095.svg'
                                    className='svg-icon svg-icon-gray-900 text-hover-primary'
                                  />
                                  {intl.formatMessage({id: 'WIKI'})}
                                </a>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  )
}

export {ListCDRPage}
